import Service from '@/domain/services/generalPanel/assetsList/assetsListService';
import eventBus from '@/services/globalEventBus';
import treeviewEvents from '@/domain/events/treeview';

export default {
  data: () => ({
    nodes: [],
  }),
  created() {
    this.getNodes();
    this.initTreeviewProviderListener();
  },
  beforeDestroy() {
    this.removeTreeviewProviderListener();
  },
  provide() {
    const tree = {};

    Object.defineProperty(tree, 'nodes', {
      enumerable: true,
      get: () => this.nodes,
    });

    return { tree };
  },
  methods: {
    initTreeviewProviderListener() {
      eventBus.on(treeviewEvents.update, this.getNodes, this);
    },
    removeTreeviewProviderListener() {
      eventBus.off(treeviewEvents.update, this.getNodes, this);
    },
    getNodes() {
      Service.getAssetsTreeviewList()
        .then((response) => {
          this.nodes = response;
        });
    },
  },
};
